import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "toggleAllLabel", "toggleAllMarker"]
  static values = { talentId: Number }

  connect() {
    this.state = this.readState()
    this.sectionTargets.forEach((section) => {
      section.open = this.state[section.dataset.sectionKey] !== false
    })
    this.updateButton()
  }

  changed(event) {
    const section = event.currentTarget
    this.state[section.dataset.sectionKey] = section.open
    this.saveState()
    this.updateButton()
  }

  toggleAll() {
    const open = !this.sectionTargets.every((section) => section.open)
    this.sectionTargets.forEach((section) => {
      section.open = open
      this.state[section.dataset.sectionKey] = open
    })
    this.saveState()
    this.updateButton()
  }

  updateButton() {
    const allOpen = this.sectionTargets.every((section) => section.open)
    this.toggleAllLabelTarget.textContent = allOpen ? "Collapse all" : "Expand all"
    this.toggleAllMarkerTarget.textContent = allOpen ? "▾" : "▸"
  }

  get storageKey() {
    return `talent-sections:v1:${this.talentIdValue}`
  }

  readState() {
    try {
      const state = JSON.parse(localStorage.getItem(this.storageKey))
      if (state && typeof state === "object" && !Array.isArray(state)) {
        return Object.fromEntries(Object.entries(state).filter(([, value]) => typeof value === "boolean"))
      }
    } catch {
      // Storage can be unavailable or contain invalid JSON; sections still work.
    }
    return {}
  }

  saveState() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.state))
    } catch {
      // Keep the current page usable when the browser cannot persist preferences.
    }
  }
}
